var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e0e9ee;}.cls-2{fill:#d0e1e8;}.cls-3{fill:#748a95;}.cls-4{fill:#f0f4f7;}.cls-5{fill:#f6e782;}.cls-6{fill:#dd5891;}.cls-7{fill:#94d8e5;}.cls-8{fill:#617880;}.cls-9{fill:#f5d96d;}.cls-10{fill:#7bd1e0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shop"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.6,30.09V52.71L32.93,54.78,14.4,52.71V30.09Z",
    id: "rect6072-0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.69,30.09V52.71H49.6V30.09Z",
    id: "path570894"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.65,52.71h44.7a1.65,1.65,0,1,1,0,3.29H9.65a1.65,1.65,0,1,1,0-3.29Z",
    id: "path140620-1-2-3-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.33,8h-5a2.46,2.46,0,0,0-2.47,2.47v6.09L33,20.26l13.16-3.7V10.47A2.46,2.46,0,0,0,43.71,8H42.24L40.51,9,39.07,8H33.94L30,9.11Z",
    id: "path554556"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M33.94,8v7.13a1.44,1.44,0,0,1-2.87,0V11.9a1.44,1.44,0,0,0-2.87,0,1.44,1.44,0,1,1-2.87,0V8Z",
    id: "path128784-6-0-2-4-7-1-2-6-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M43.51,33a3.84,3.84,0,0,0,7.67,0v-4.7a8.44,8.44,0,0,0-1-3.9l-4-7.82H40.51L38,18.86l-3.16-2.3H29.16l-3.74,1.85-1.93-1.85H17.82l-4.05,7.82a8.44,8.44,0,0,0-.95,3.9V33a3.84,3.84,0,0,0,7.67,0h7.67a3.84,3.84,0,0,0,7.68,0Z",
    id: "rect4203-9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M23.49,16.56l-3,9.66V33a3.84,3.84,0,0,0,7.67,0V26.22l1-9.66Zm11.35,0,1,9.66V33a3.84,3.84,0,0,0,7.67,0V26.22l-3-9.66Z",
    id: "path5151-0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M26,40.84H44.48a1.61,1.61,0,0,1,1.62,1.62v3.22a1.62,1.62,0,0,1-1.62,1.62H26l-1.56-2.92Z",
    id: "rect6501-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M21.24,40.84H26V52.71h-6.6v-10A1.84,1.84,0,0,1,21.24,40.84Z",
    id: "rect6476-9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M49.88,52.71a1.65,1.65,0,0,1,0,3.29h4.47a1.65,1.65,0,1,0,0-3.29Z",
    id: "path577397"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M43.32,16.56l4,7.82a8.44,8.44,0,0,1,1,3.9V33a3.83,3.83,0,0,1-2.4,3.56,3.75,3.75,0,0,0,1.43.27A3.82,3.82,0,0,0,51.18,33v-4.7a8.44,8.44,0,0,0-1-3.9l-4-7.82Z",
    id: "path587337"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M46.18,16.56V10.47A2.46,2.46,0,0,0,43.71,8H41.55l-.12.07a2.46,2.46,0,0,1,1.92,2.4v6.09Z",
    id: "path589951"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42.24,8v4.33a1.59,1.59,0,0,1-3.17,0V8Z",
    id: "rect8129-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M41.6,40.84a1.61,1.61,0,0,1,1.62,1.62v3.22A1.62,1.62,0,0,1,41.6,47.3h2.88a1.62,1.62,0,0,0,1.62-1.62V42.46a1.61,1.61,0,0,0-1.62-1.62Z",
    id: "path606856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.35,21a1,1,0,0,0,1.36-.37,1,1,0,0,0-.36-1.37L13,19.08a1,1,0,1,0-1,1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8,18.36a.93.93,0,0,0,.5.14,1,1,0,0,0,.51-1.87l-.31-.17a1,1,0,0,0-1.37.36,1,1,0,0,0,.37,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.13,20.62A1,1,0,0,0,8.5,21l.3-.18a1,1,0,0,0-1-1.73l-.31.17A1,1,0,0,0,7.13,20.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.35,16.46l-.31.17a1,1,0,0,0,1,1.74l.31-.18a1,1,0,0,0,.36-1.37A1,1,0,0,0,12.35,16.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42,21.52a1,1,0,0,0,2,0v-.35a1,1,0,0,0-2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.42,15.92v.36a1,1,0,0,0,2,0v-.36a1,1,0,0,0-2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.35,51.71H50.6V36.53A4.77,4.77,0,0,0,52.18,33v-4.7a9.58,9.58,0,0,0-1.06-4.36l-3.94-7.6V10.47A3.47,3.47,0,0,0,43.71,7H20.29a3.47,3.47,0,0,0-3.47,3.47v5.85l-3.94,7.6a9.58,9.58,0,0,0-1.06,4.36V33a4.77,4.77,0,0,0,1.58,3.55V51.71H9.65a2.65,2.65,0,1,0,0,5.29h44.7a2.65,2.65,0,1,0,0-5.29ZM13.82,33v-4.7a7.56,7.56,0,0,1,.08-1.06h5.59V33a2.84,2.84,0,0,1-5.67,0Zm7.67-5.76h5.67V33a2.84,2.84,0,0,1-5.67,0Zm6.57-9.66-.8,7.66H21.85l2.38-7.66Zm4-2.44V11.9a2.44,2.44,0,0,0-4.87,0,.44.44,0,1,1-.87,0V9h6.61v6.12a.44.44,0,1,1-.87,0Zm7.7,2.44,2.38,7.66H36.74l-.8-7.66Zm-5.84,0,.8,7.66H29.27l.8-7.66Zm-4.77,9.66h5.68V33a2.84,2.84,0,0,1-5.68,0Zm7.68,0h5.67V33a2.84,2.84,0,0,1-5.67,0Zm7.67,0H50.1a7.56,7.56,0,0,1,.08,1.06V33a2.84,2.84,0,0,1-5.67,0Zm4.83-2.38c.07.12.11.25.17.38H44.25l-2.38-7.66h3.7ZM45.18,10.47v5.09H34.9a3.13,3.13,0,0,0,0-.44V9h3.13v3.33a2.59,2.59,0,0,0,5.17,0V9h.47A1.47,1.47,0,0,1,45.18,10.47ZM40.07,9h1.17v3.33a.59.59,0,0,1-1.17,0ZM20.29,9h4v2.9a2.44,2.44,0,1,0,4.87,0,.44.44,0,0,1,.87,0v3.22a2.12,2.12,0,0,0,.05.44H18.82V10.47A1.47,1.47,0,0,1,20.29,9Zm-1.86,8.56h3.7l-2.38,7.66H14.49c.06-.13.1-.26.17-.38Zm-3,20.07a4.72,4.72,0,0,0,1.25.18,4.82,4.82,0,0,0,3.84-1.89,4.84,4.84,0,0,0,7.67,0,4.85,4.85,0,0,0,7.68,0,4.84,4.84,0,0,0,7.67,0,4.82,4.82,0,0,0,3.84,1.89,4.72,4.72,0,0,0,1.25-.18V51.71H27V48.3H44.48a2.62,2.62,0,0,0,2.62-2.62V42.46a2.62,2.62,0,0,0-2.62-2.62H21.24a2.85,2.85,0,0,0-2.85,2.84v9h-3Zm23.34,4.21V46.3H33.35V41.84Zm5.74,0a.62.62,0,0,1,.62.62v3.22a.62.62,0,0,1-.62.62H40.74V41.84ZM31.35,46.3H27V41.84h4.36ZM25,51.71h-4.6v-9a.85.85,0,0,1,.85-.84H25ZM54.35,55H9.65a.65.65,0,1,1,0-1.29h44.7a.65.65,0,1,1,0,1.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.51,
    cy: 21.06,
    r: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.86,
    cy: 44.24,
    r: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.19,12.89l.31.17a.93.93,0,0,0,.5.14,1,1,0,0,0,.5-1.87l-.31-.17a1,1,0,0,0-1.36.36A1,1,0,0,0,55.19,12.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.29,8.9a1,1,0,0,0,.36,1.37l.31.17a1,1,0,0,0,.5.14A1,1,0,0,0,52,8.71l-.31-.18A1,1,0,0,0,50.29,8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,11.16l-.31.17a1,1,0,0,0,.5,1.87.9.9,0,0,0,.5-.14l.31-.17a1,1,0,0,0,.36-1.37A1,1,0,0,0,51,11.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.69,10.58a1,1,0,0,0,.5-.14l.31-.17a1,1,0,1,0-1-1.74l-.31.18a1,1,0,0,0-.36,1.37A1,1,0,0,0,55.69,10.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.58,12.25h0a1,1,0,0,0-1,1v.36a1,1,0,0,0,1,1h0a1,1,0,0,0,1-1v-.35A1,1,0,0,0,53.58,12.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.58,7a1,1,0,0,0-1,1v.35a1,1,0,1,0,2,0V8A1,1,0,0,0,53.58,7Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketNew);
export default __webpack_public_path__ + "static/media/market_new.b1e6e15a2ce68a56ae497dff6ef89fed.svg";
export { ForwardRef as ReactComponent };